import { CloudType } from '@labrav/react-components'
import { AnyAction, Reducer } from 'redux'
import { TemplateRows } from '../../../oppsync/modules/productAccount/reducer'
import { CLOUD_ACCOUNT_ACTIONS } from './actionTypes'

export enum AccountType {
  ROOT,
  ORGANIZATION_UNIT,
  MEMBER,
}

export type SegmentAndGreenField = {
  results: {
    fileName: string
    createdAt: string
    createdBy: string
  }[]
}

export type Account = {
  id: string
  cloudType: CloudType
  organizationId: string
  accountDetails: {
    id: string
    externalAccountId: string
    name: string
    type: AccountType
    cloudAccountId: string
    roles: { rows: TemplateRows[] }
    createdAt?: string
    status?: string
  }
}

export type CloudAccountState =
  | (Account[] & { segmentAndGreenField?: SegmentAndGreenField })
  | null

export const initialState = null

export const reducer: Reducer<CloudAccountState> = (
  state = initialState,
  action: AnyAction
) => {
  switch (action.type) {
    case CLOUD_ACCOUNT_ACTIONS.SET_ACCOUNTS: {
      return action.payload
    }
    case CLOUD_ACCOUNT_ACTIONS.SET_SEGMENT_AND_GREEN_FIELD: {
      return { ...state, segmentAndGreenField: action.payload }
    }
    case CLOUD_ACCOUNT_ACTIONS.UPDATE_SEGMENT_AND_GREEN_FIELD: {
      const segmentAndGreenField = state?.segmentAndGreenField
      if (!segmentAndGreenField) {
        return {
          ...state,
        }
      } else {
        let result = [...segmentAndGreenField.results]
        result = [action.payload, ...result]
        return {
          ...state,
          segmentAndGreenField: {
            ...segmentAndGreenField,
            results: [...result],
          },
        }
      }
    }
    default:
      return state
  }
}
